import { AppointmentCard } from 'components/load-appointments';
import { TripContext } from 'contexts';
import React, { Fragment, useContext } from 'react';
import { useParamService } from 'services';
import { Stop } from 'services/types';
import './load-appointments.scss';

export const LoadAppointmentPage = () => {

    const { getIntValue } = useParamService
    const tripContext = useContext(TripContext)

    const tripId: number | undefined = getIntValue('tripId')
    const stops: Stop[] = tripContext.stops.filter(stop => stop.tripId === tripId)

    stops.sort((a: Stop, b: Stop): number => {
        if (a.appointmentTime == null) return -1
        else if (b.appointmentTime == null) return 1
        else return (a.appointmentTime < b.appointmentTime ?? new Date()) ? -1 : 1
    })

    return (
        <Fragment>
            {stops.length > 0 &&
                stops.map(stop => <AppointmentCard key={stop.id} stopId={stop.id} />)
            }
        </Fragment>
    )
};
